import {Component, computed, input, OnDestroy, resource, ChangeDetectionStrategy} from '@angular/core';
import {User} from '../../../api/models/user';
import {PreferenceListComponent} from './preference-list/preference-list.component';
import {SurveyAssignmentComponent} from '../survey-assignment/survey-assignment.component';
import {
  WaCalloutDirective,
  WaIconDirective,
  WaTabComponent,
  WaTabGroupComponent,
  WaTabPanelComponent,
  WaToastService
} from "angular-awesome";
import {SurveyService} from "../../../api/services/survey.service";
import {Subscription} from "rxjs";
import {Exam} from "../../../api/models/exam";
import {AuthService} from "../../../api/services/auth.service";

@Component({
    standalone: true,
    selector: 'app-survey-preferences',
    templateUrl: './survey-preferences.component.html',
    styleUrls: ['./survey-preferences.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    PreferenceListComponent,
    SurveyAssignmentComponent,
    WaTabComponent,
    WaTabGroupComponent,
    WaTabPanelComponent,
    WaCalloutDirective,
    WaIconDirective
  ]
})
export class SurveyPreferencesComponent implements OnDestroy {

  surveyId = input.required<number>();
  params = computed(() => ({
    id: this.surveyId(),
  }));

  private userSub: Subscription = new Subscription();

  selectedExam: Exam | null = null;
  currentUser: User | null = null;
  currentSurvey = resource({
    params: this.params,
    loader: ({ params }) => this.fetchSurvey(params),
  });

  constructor(private authService: AuthService,
    private surveyService: SurveyService,
    private toastService: WaToastService) {

    this.userSub = this.authService.loggedInUser$.subscribe({
      next: user => this.currentUser = user,
      error: err => {
        this.toastService.danger('Error: Could not fetch current user.');
      }
    });
  }

  private fetchSurvey({id}:  {id: number })
  {
    console.log("Fetching survey with id "+id)
    return this.surveyService.get(id);
  }

  ngOnDestroy(): void {
    this.userSub.unsubscribe();
  }
}
